import "@/shared/social-share-popup";
import '~/css/shared/modules/breadcrumbs_plain.css';
import "~/css/shared/social-share-popup.css";
import '~/css/shared/skeleton_loader.css';
import '~/css/shared/3d-models/carousel.css';
import '~/css/shared/panel.css';
import '~/css/shared/badges.css';
import '~/css/pages/3d-models/view.css';

import $ from '@/bundles/jquery';
import CommentManager from "@/shared/3d-models/comments";
import ModelView from "@/shared/3d-models/model-view";

var fileExplorerElement = document.getElementById('fileExplorer');
var descriptionElement = document.getElementById('description');
var galleryElement = document.getElementById('gallery');

var commentSection = document.getElementById('comments');
var commentManager = commentSection ? new CommentManager(global.modelId, commentSection) : null;

var sectionSimilarWrap = document.getElementById('sectionSimilarWrap');

var adminActionsContainer = document.getElementById('adminActionsContainer');
var btnLikeElement = document.getElementById('btnLike');
var btnFollowElement = document.getElementById('btnFollow');
var btnHireElement = document.getElementById('btnHire');
var btnEmbedElement = document.getElementById('btnEmbed');

new ModelView(
    global.modelData,
    global.modelId,
    global.folderId,
    global.baseUrl,
    global.modelName,
    fileExplorerElement,
    descriptionElement,
    galleryElement,
    commentManager,
    adminActionsContainer,
    btnLikeElement,
    btnFollowElement,
    btnHireElement,
    btnEmbedElement,
    sectionSimilarWrap
);

$('#btnDownloadZip').on('click', function() {
    $(this).addClass('disabled');
});
